module.exports = __webpack_public_path__ + "img/logo_yiguoqi@2x.20ef709a.png";